import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { accountsAPI } from '../../lib/api';

const ChartOfAccounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAccounts = async () => {
    setLoading(true);
    try {
      const response = await accountsAPI.getAll();
      setAccounts(response.data);
    } catch (error) {
      console.error('Error fetching accounts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Account Name' },
    { key: 'type', label: 'Type', type: 'status' },
    { key: 'balance', label: 'Balance', type: 'currency' },
    { key: 'description', label: 'Description' },
  ];

  const formFields = [
    { name: 'code', label: 'Account Code', required: true, placeholder: 'e.g., 1000' },
    { name: 'name', label: 'Account Name', required: true, placeholder: 'Account name' },
    {
      name: 'type',
      label: 'Account Type',
      type: 'select',
      required: true,
      options: [
        { value: 'asset', label: 'Asset' },
        { value: 'liability', label: 'Liability' },
        { value: 'equity', label: 'Equity' },
        { value: 'revenue', label: 'Revenue' },
        { value: 'expense', label: 'Expense' },
      ],
    },
    {
      name: 'parent_id',
      label: 'Parent Account',
      type: 'select',
      defaultValue: 'none',
      // Round 10: optional hierarchy; the empty option leaves the account top-level.
      options: [{ value: 'none', label: 'None (top-level account)' }, ...accounts.map((a) => ({ value: a.id, label: `${a.code} - ${a.name}` }))],
    },
    { name: 'balance', label: 'Opening Balance', type: 'number', defaultValue: 0 },
    { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Account description' },
  ];

  const handleAdd = async (data) => {
    const payload = { ...data, parent_id: (!data.parent_id || data.parent_id === 'none') ? null : data.parent_id };
    await accountsAPI.create(payload);
    fetchAccounts();
  };

  const handleEdit = async (id, data) => {
    const payload = { ...data, parent_id: (!data.parent_id || data.parent_id === 'none') ? null : data.parent_id };
    await accountsAPI.update(id, payload);
    fetchAccounts();
  };

  const handleDelete = async (id) => {
    await accountsAPI.delete(id);
    fetchAccounts();
  };

  return (
    <DataTable
      title="Chart of Accounts"
      description="Manage your account structure"
      data={accounts}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="name"
    />
  );
};

export default ChartOfAccounts;
